import { Injectable } from '@angular/core';
import { ObjectDiffService } from './object-diff.service';

@Injectable({
  providedIn: 'root'
})
export class PumpsetDiffService {

  constructor(private objectDiffService: ObjectDiffService) { }

  diff(pumpset1: any, pumpset2: any) {
    let result = [];
    result = result.concat(this.objectDiffService.diff(pumpset1, pumpset2, ['name']));
    result = result.concat(this.objectDiffService.diff(pumpset1.pumpsetDetails, pumpset2.pumpsetDetails, ["numberOfBoosterLayers", "numberOfBackingPumpsInParallel", "hasUserBackingPump",
      "backingPumpId", "backingPumpName", "backingPumpGas"]));
    let boosterLayerDiffs=[];
    let boosterLayerFields=["numberOfBoostersInParallel"];
    let boosterDetailFields=["initialFrequency","userMaximumFrequency","pressureSwitch","rootsName","GXB1750","statorTemperature","deltaTemperatureRotorStator","driveName"];
    if(pumpset1.pumpsetDetails.boosterLayersDetails.length >= pumpset2.pumpsetDetails.boosterLayersDetails.length) {
      pumpset1.pumpsetDetails.boosterLayersDetails.forEach((boosterLayer, index) => {
        let boosterDetailDiff=this.objectDiffService.diff(boosterLayer.boosterDetails, pumpset2.pumpsetDetails.boosterLayersDetails[index]?pumpset2.pumpsetDetails.boosterLayersDetails[index].boosterDetails:{},boosterDetailFields);
        let boosterLayerDiff=this.objectDiffService.diff(boosterLayer, pumpset2.pumpsetDetails.boosterLayersDetails[index]?pumpset2.pumpsetDetails.boosterLayersDetails[index]:{},boosterLayerFields);        
        boosterLayerDiffs[index] = boosterDetailDiff.concat(boosterLayerDiff);              
      });
   }  else {
      pumpset2.pumpsetDetails.boosterLayersDetails.forEach((boosterLayer, index) => {       
        let boosterDetailDiff=this.objectDiffService.diff(pumpset1.pumpsetDetails.boosterLayersDetails[index] ? pumpset1.pumpsetDetails.boosterLayersDetails[index].boosterDetails : {},boosterLayer.boosterDetails,boosterDetailFields);
        let boosterLayerDiff=this.objectDiffService.diff(pumpset1.pumpsetDetails.boosterLayersDetails[index]?pumpset1.pumpsetDetails.boosterLayersDetails[index]:{},boosterLayer,boosterLayerFields);
        boosterLayerDiffs[index]=boosterDetailDiff.concat(boosterLayerDiff);    
      })
    }
    result.push({boosterLayerDiffs:boosterLayerDiffs});
    return result;
  }

  diffToString(pumpset1: any, pumpset2: any){
    let diffs = this.diff(pumpset1,pumpset2);    
    let result="";
    diffs.forEach(diff=>{      
      if(diff.property){
        result+=diff.property+" "+diff.from+"=>"+diff.to+"\n";
      }      
    })
    diffs[diffs.length-1].boosterLayerDiffs.forEach((bldiffs,index) => {      
      bldiffs.forEach(diff => {
        result+="Booster Layer " + (diffs[diffs.length-1].boosterLayerDiffs.length-index) + " " + diff.property + " " + diff.from + "=>" + diff.to + "\n";  
      });      
    });
    return result;
  }

  diffToHTML(pumpset1: any, pumpset2: any){
    let diffs = this.diff(pumpset1,pumpset2);    
    let result="";
    diffs.forEach(diff=>{      
      if(diff.property){
        result+=diff.property+" "+diff.from+"=>"+diff.to+"</br>";
      }      
    })
    diffs[diffs.length-1].boosterLayerDiffs.forEach((bldiffs,index) => {      
      bldiffs.forEach(diff => {
        result+="Booster Layer " + (diffs[diffs.length-1].boosterLayerDiffs.length-index) + " " + diff.property + " " + diff.from + "=>" + diff.to + "</br>";  
      });      
    });
    return result;
  }

}

